module.exports = __webpack_public_path__ + "img/1-1.da21f134.svg";